import { FC, React, useContext } from 'external/react'
import { TeacherContext } from 'teacher/context'
import { TextAreaField } from 'components/common/TextAreaField'

import {styled} from 'external/material'

import GeneralInfoField from './GeneralInfoField'

type GeneralInfoProps = {
    className?: string
}

const StyledGeneralInfo = styled('div')(generalInfoStyles as any)

const GeneralInfo: FC<GeneralInfoProps> = props => {
    
    const {className} = props
    const { profile, newPlan, myGrades, mySubjects} = useContext(TeacherContext) as any

    const grade = myGrades.find((grade: any) => newPlan.grade == grade.id)
    const subject = mySubjects.find((subject: any) => newPlan.subject == subject.id)

    return (
        <StyledGeneralInfo className={className}>
            <div className='field-group'>
                <div className='field-row'>    
                    <GeneralInfoField id='titulo' required />
                    <GeneralInfoField id='docente' readonlyValue={`${profile?.individual.last_name}, ${profile?.individual.first_name}`} />
               </div>
                <div className='field-row'>
                    <GeneralInfoField id='asignatura' readonlyValue={subject?.name ?? ''} />
                    <GeneralInfoField id='grado' readonlyValue={grade?.name ?? ''} />
                    <GeneralInfoField id='section' />
                    <GeneralInfoField id='estimatedTime' />
               </div>
            </div>
            <div className='field-group'>
                <GeneralInfoField id='learningUnit' />
                <GeneralInfoField id='thematicAxis' />
                <GeneralInfoField id='learningSituation' Component={TextAreaField}/>
            </div>
        </StyledGeneralInfo>
    )
}

function generalInfoStyles() {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: '30px',
        alignItems: 'center',
        '& > .field-group': {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: '30px'
        },
        '& .field-row': {
            display: 'flex',
            gap: '30px',
            width: '100%',
            flex: 1
        }
    }
}

export {GeneralInfo as default}